import $ from "jquery";

const showPassword = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      main: ".js-show-password",
    };

    if ($(el.main).length === 0) return;

    $(document).on("change", el.main, function () {
      const target = $(this).data("target");
      const thisCheck = $(this).is(":checked");
      $(target).attr("type", thisCheck ? "text" : "password");
    });
  };
  init();
};

try {
  showPassword();
} catch (error) {
  console.error("showPassword", error);
}
